export default __webpack_public_path__ + "static/media/AppStore.e7fac4ea.svg";